export default __webpack_public_path__ + "static/media/hache.c20f7f8b.png";